import React, { useState } from "react";
import styles from "./LocationList.module.css";

const LocationList = ({
  locationCentre,
  locationSearchMode = "My Country",
  onLocationSelect,
}) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  // Get status for a specific location
  const getLocationStatus = (locationId) => {
    const record = locationCentre.find(
      (location) => location.location_id == locationId,
    );
    return record?.status ?? 1;
  };

  // Get verified date for a specific location
  const getVerifiedDate = (locationId) => {
    const record = locationCentre.find(
      (location) => location.location_id == locationId,
    );
    return record?.verified_date;
  };

  // Toggle status between available and closed
  const toggleStatus = (locationId, e) => {
    e.stopPropagation();
    const currentStatus = getLocationStatus(locationId);
    const newStatus = currentStatus === 1 ? 0 : 1;

    // Update the join record status
    const location = locationCentre.find(
      (location) => location.location_id == locationId,
    );
    if (location) {
      location.status = newStatus;
      setSelectedLocation(location);
    }
  };

  // Handle line click
  const handleLineClick = (location) => {
    setSelectedLocation(location);
    setShowConfirmation(true);
  };

  // Handle confirmation OK
  const handleConfirmOk = () => {
    if (selectedLocation) {
      const status = getLocationStatus(selectedLocation.id);
      onLocationSelect(selectedLocation, status);
      setShowConfirmation(false);
      setSelectedLocation(null);
    }
  };

  // Handle confirmation Back
  const handleConfirmBack = () => {
    setShowConfirmation(false);
    setSelectedLocation(null);
  };

  // Format location display text
  const getLocationDisplay = (location) => {
    let display = `${location.town}, ${location.region}`;
    if (location.postcode) {
      display += `, ${location.postcode}`;
    }
    if (locationSearchMode.toLowerCase() === "global" && location.country) {
      display += `, ${location.country}`;
    }
    return display;
  };

  return (
    <div className={styles.container}>
      <div className={styles.listContainer}>
        {locationCentre.length === 0 && (
          <p className={styles.notFound}>No location found</p>
        )}
        {locationCentre.map((location) => {
          const status = getLocationStatus(location.id);
          const verifiedDate = getVerifiedDate(location.id);
          const buttonText =
            status === 0 ? "Closed" : verifiedDate || "Available";
          const isClosed = status === 0;

          return (
            <div
              key={location.id}
              className={`${styles.rowCard} ${isClosed ? styles.disabled : ""}`}
              onClick={() => handleLineClick(location)}
            >
              <div className={styles.locationInfo}>
                <span className={styles.val}>
                  {getLocationDisplay(location)}
                </span>
              </div>
              <div className={styles.spacer} />
              <button
                className={`${styles.statusButton} ${isClosed ? styles.closed : styles.available}`}
                onClick={(e) => toggleStatus(location.id, e)}
              >
                {buttonText}
              </button>
            </div>
          );
        })}
      </div>

      {/* Confirmation Modal */}
      {showConfirmation && selectedLocation && (
        <div className={styles.modalOverlay} onClick={handleConfirmBack}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className={styles.modalTitle}>Confirm Location</h3>
            <p className={styles.modalText}>
              You have used this location in {selectedLocation.town},{" "}
              {selectedLocation.region}?
            </p>
            <div className={styles.modalButtons}>
              <button
                className={`${styles.modalButton} ${styles.backButton}`}
                onClick={handleConfirmBack}
              >
                Back
              </button>
              <button
                className={`${styles.modalButton} ${styles.okButton}`}
                onClick={handleConfirmOk}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationList;
